import React from 'react';
import { GeneralProvider, useGeneral } from '../../Context/GeneralContext';
import '../../styles/llamados.css';

import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import ModalM from '../ModalM';
import ModalConfirm from '../ModalConfirm';
import ActionToast from '../ActionToast/ActionToast';

function Llamados({rowData, hideButtons}) {
    const { handleClickB, openSnack, setOpenSnack, mensaje, tipoMensaje } =
        useGeneral();

    return (
        <div className={`homeView-head-llamados${hideButtons ? ' homeView-head-llamados--hidden' : ''}`}>
            <div className="homeView-head-llamados-buttons">
                <ButtonGroup
                    variant="contained"
                    color="primary"
                    aria-label="contained primary button group"
                    size="large"
                    className="homeView-head-llamados-buttongroup"
                >
                    <Button
                        className="homeView-head-llamados-button1"
                        onClick={(e) => handleClickB('#dd1717', 'Rojo', '#FCCACD', 0, 'Mantenimiento', rowData)}
                    >
                        <h1>M</h1>
                    </Button>
                    <Button
                        className="homeView-head-llamados-button2"
                        onClick={(e) => handleClickB('#ffc800', 'Amarillo', '#3D3207', 0, 'Almacén', rowData)}
                    >
                        <h1>A</h1>
                    </Button>
                    <Button
                        className="homeView-head-llamados-button3"
                        onClick={(e) => handleClickB('#00a375', 'Verde', '#C9FFEF', 0, 'Producción', rowData)}
                    >
                        <h1>P</h1>
                    </Button>
                    <Button
                        className="homeView-head-llamados-button4"
                        onClick={(e) => handleClickB('#0000FF', 'Azul', '#F2F4F8', 0, 'Calidad', rowData)}
                    >
                        <h1>C</h1>
                    </Button>
                </ButtonGroup>
            </div>
            <ModalM />
            <ModalConfirm />
            <ActionToast
                open={openSnack}
                message={mensaje}
                severity={tipoMensaje}
                duration={3000}
                onClose={() => setOpenSnack(false)}
            />
        </div>
    );
}

const LlamadosWithContext = ({rowData, hideButtons}) => (
    <GeneralProvider>
        <Llamados rowData={rowData} hideButtons={hideButtons}></Llamados>
    </GeneralProvider>
);

export default LlamadosWithContext;